module.exports = __webpack_public_path__ + "static/flags/CQ-f32bfa6f3966639fb0e633cb1f51db6e.gif";